import { createApi } from '@reduxjs/toolkit/query/react';
import { createBaseQuery } from '../baseApi';

export interface MaterialItem {
  ID: number;
  MATERIAL_ID: string;
  MATERIAL_NAME: string;
  MATERIAL_TYPE: string;
  MATERIAL_GROUP: string;
  PLANT: string;
  COMPANY_CODE: string;
  MATERIAL_BASE_UNIT: string;
  ACTIVE: boolean;
}

export interface GetMaterialMasterResponse {
  message: string;
  items: MaterialItem[];
  pagination: {
    total: number;
    page: number;
    limit: number;
    totalPages: number;
  };
}

export interface SyncMaterialResponse {
  message: string;
  items: MaterialItem[];
}

export const materialApi = createApi({
  reducerPath: 'materialApi',
  baseQuery: createBaseQuery('spares/'),
  tagTypes: ['Material'],
  endpoints: (builder) => ({
    getMaterialMaster: builder.query<
      GetMaterialMasterResponse,
      {
        page?: number;
        limit?: number;
        materialId?: string;
        materialName?: string;
        plant?: string;
        q?: string;
      }
    >({
      query: (params) => ({
        url: '',
        params: {
          page: params.page || 1,
          limit: params.limit || 1000, // Fetch all for local pagination
          ...params,
        },
      }),
      providesTags: ['Material'],
    }),
    syncMaterialFromSap: builder.mutation<SyncMaterialResponse, void>({
      query: () => ({
        url: 'syncMaterialMaster',
        method: 'GET',
      }),
      invalidatesTags: ['Material'],
    }),
  }),
});

export const { useGetMaterialMasterQuery, useSyncMaterialFromSapMutation } = materialApi;
